var map = {
	"./frame_01.webp": 9764,
	"./frame_02.webp": 43909,
	"./frame_03.webp": 16910,
	"./frame_04.webp": 49847,
	"./frame_05.webp": 87416,
	"./frame_06.webp": 31337,
	"./frame_07.webp": 76146,
	"./frame_08.webp": 68155,
	"./frame_09.webp": 99148,
	"./frame_10.webp": 11290,
	"./frame_11.webp": 30801,
	"./frame_12.webp": 79104,
	"./frame_13.webp": 90527,
	"./frame_14.webp": 41942,
	"./frame_15.webp": 88685,
	"./frame_16.webp": 76300,
	"./frame_17.webp": 99675,
	"./frame_18.webp": 4914,
	"./frame_19.webp": 9577,
	"./frame_20.webp": 20201,
	"./frame_21.webp": 13938,
	"./frame_22.webp": 23895,
	"./frame_23.webp": 87032,
	"./frame_24.webp": 92101,
	"./frame_25.webp": 86990,
	"./frame_26.webp": 30419,
	"./frame_27.webp": 96036,
	"./frame_28.webp": 42065,
	"./frame_29.webp": 4538,
	"./frame_30.webp": 11464,
	"./frame_31.webp": 86727,
	"./frame_32.webp": 97026,
	"./frame_33.webp": 78777,
	"./frame_34.webp": 29044,
	"./frame_35.webp": 42755,
	"./frame_36.webp": 41406,
	"./frame_37.webp": 9397,
	"./frame_38.webp": 46864,
	"./frame_39.webp": 69551,
	"./frame_40.webp": 32871,
	"./frame_41.webp": 35176,
	"./frame_42.webp": 94521,
	"./frame_43.webp": 63682,
	"./frame_44.webp": 20195,
	"./frame_45.webp": 71764,
	"./frame_46.webp": 53909,
	"./frame_47.webp": 96830,
	"./frame_48.webp": 1807,
	"./frame_49.webp": 15280,
	"./frame_50.webp": 2702,
	"./frame_51.webp": 7813,
	"./frame_52.webp": 95396,
	"./frame_53.webp": 46131,
	"./frame_54.webp": 13298,
	"./frame_55.webp": 19561,
	"./frame_56.webp": 86392,
	"./frame_57.webp": 23255,
	"./frame_58.webp": 25142,
	"./frame_59.webp": 72365,
	"./frame_60.webp": 26909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77396;